import React from 'react';
import { modules } from '../data/modules';
export function Modules() {
  return <section className="bg-white px-4 py-4" data-id="element-111" data-mp="1r6c4qxh69jwe">
      <div className="mx-auto max-w-3xl" data-id="element-112" data-mp="1r510yxnq8c5a">
        <h2 className="mb-2.5 text-center font-display text-[21px] leading-tight sm:text-3xl" data-id="element-113" data-mp="1r3zhc4snahby">
          What&apos;s Included
        </h2>
        <ul className="space-y-2" data-id="element-114" data-mp="20wezb23xz5wu">
          {modules.map(module => <li key={module.number} data-id="element-115" data-mp="20xzu8su64qv8">
              <article className="overflow-hidden rounded-lg border border-brand-line bg-brand-paper" style={{
            borderLeft: `6px solid ${module.color}`
          }} data-id="element-116" data-mp="146o4f1rqngqi">
                <div className="p-3" data-id="element-117" data-mp="1d6uba4sxligp">
                  <h3 className="mb-1 font-cond text-[14px] font-bold leading-snug sm:text-lg" data-id="element-118" data-mp="1d5t2k6ze1825">
                    <span className="mr-1 text-brand-carbon" data-id="element-119" data-mp="1i6gnqc0xquog">✅ Module {module.number} —</span>
                    <span style={{
                  color: module.color
                }} data-id="element-120" data-mp="2okogfqq7n5hn">{module.title}</span>
                  </h3>
                  <p className="text-[13px] font-medium leading-snug text-brand-muted sm:text-[15px]" data-id="element-121" data-mp="2tmx7ghjivxh4">
                    {module.body}
                  </p>
                  <p className="mt-1 font-cond text-[12px] font-bold uppercase tracking-wide text-brand-carbon sm:text-sm" data-id="element-122" data-mp="3tzx3xqujzndp">
                    {module.tagline}
                  </p>
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}